import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openCustomDialog } from '../../../redux/slices/customDialogSlice';
import ShortVideoCreate from '../../../app/shoppable/shortVideo/ShortVideoCreate';

const CreateShortVideoAction = ({ payload, onComplete }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const onCancel = onComplete ? () => onComplete(null) : undefined;
        dispatch(openCustomDialog(<ShortVideoCreate asset={payload} onComplete={onComplete} onCancel={onCancel}/>, {
            beforeClose: onCancel,
        }));
        // eslint-disable-next-line
    }, []);
};

export default CreateShortVideoAction;
